import moment from 'moment';
import { ActivityLog } from 'types';

export const filterYesterdayActivities = (activities: ActivityLog[]) =>
  activities.filter((activity) => moment(activity.createdAt).isSame(moment().subtract(1, 'days'), 'day'));
